





















































import { mapState } from "vuex";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import { Locale } from "@/constants/locale";
export default {
  name: "SidePanel",
  data() {
    return {
      Locale,
      TRANSLATION_KEY: "SidePanel",
      isDarkMode: false,
      isClosed: true,
    };
  },
  methods: {
    checkBody() {
      const body = document.querySelector("body");
      setTimeout(() => {
        if (body && body.classList.contains("auto-dark-theme")) {
          //@ts-ignore
          this.isDarkMode = true;
        }
      }, 100);
    },
  },
  mounted() {
    //@ts-ignore
    this.checkBody();
    const SidePanelInterval = setInterval(() => {
      //@ts-ignore
      if (!this.isLocked) {
        clearInterval(SidePanelInterval);
        setTimeout(() => {
          //@ts-ignore
          this.isClosed = false;
        }, 2000);
      }
    }, 100);
  },

  computed: {
    UtilityHelper() {
      return UtilityHelper;
    },
    ...mapState({
      isLocked: (state: any) => state.isLocked,
    }),
  },
};
